"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Tab.scss");

var _useItemSelect = _interopRequireDefault(require("../../../hooks/itemSelect/useItemSelect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Tab = function Tab(props) {
  var _useTab = (0, _useItemSelect["default"])(props),
      _useTab2 = _slicedToArray(_useTab, 2),
      setChecked = _useTab2[0],
      classes = _useTab2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-tab-secondary ' + classes,
    tabindex: props.id,
    onClick: setChecked
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-tab-secondary-id'
  }, props.id), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-tab-secondary-text'
  }, props.children));
};

Tab.propTypes = {
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  children: _propTypes["default"].any.isRequired
};
Tab.defaultProps = {
  checked: false,
  disabled: false
};
var _default = Tab;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Tab/Secondary/Tab.js
// module id = 1927
// module chunks = 0